import React from 'react';
import './PortraitHint.css';

/**
 * Hinweis-Fläche am Handy im Hochformat: bittet um Querformat, zeigt Leben und Zugnummer
 * und lässt den Zug trotzdem beenden.
 */
export default function PortraitHint({ life, turnNumber, canEndTurn, onEndTurn, onRequestLandscape }) {
  return (
    <div className="portrait-hint" data-testid="portrait-hint">
      <p className="portrait-hint__text">Bitte das Handy quer halten</p>
      <button type="button" className="btn-primary" onClick={onRequestLandscape}>Quer anzeigen</button>
      <div className="portrait-hint__stats">
        <span className="portrait-hint__life">{life}</span>
        <span className="portrait-hint__turn">Zug {turnNumber}</span>
      </div>
      <button type="button" className="btn-secondary" disabled={!canEndTurn} onClick={onEndTurn}>Zug beenden</button>
    </div>
  );
}
